import { Component, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { BaseComponent } from '../../components/base/base.component';
import { AppConfigService } from '../../config/app-config.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent extends BaseComponent implements OnInit {
  helpStyle: string = 'is-closed';
  notificationStyle: string = 'is-closed';
  AuthSubscribtion: Subscription;
  public UserName = null;
  currentRoute: string;
  protected apiUrl = AppConfigService.settings.AppConfig.API_ENDPOINT
  protected dataPortalUrl = AppConfigService.settings.AppConfig.DATAPORTAL_URL
  notification: any;
  errorMessage: any;
  isMobileMenuOpen: boolean = false;
  searchStyle: string = 'is-closed';
  // CallMe = require('/assets/js/stacked-table.js')
  constructor(private modalService: BsModalService,
    private renderer: Renderer2,
    private router: Router,
    private SpinnerService: NgxSpinnerService) {
    super(modalService)
  }

  ngOnInit(): void {
    this.SpinnerService.show();
  }


  ShowMobileMenu() {
    const showMenu = 'show-menu';
    if (this.isMobileMenuOpen) {
      this.renderer.removeClass(document.body, showMenu);
      this.isMobileMenuOpen = false;
    } else {
      this.renderer.addClass(document.body, showMenu);
      this.isMobileMenuOpen = true;
    }
  }
  HelpOnOver() {
    this.helpStyle = 'is-open';
    this.renderer.addClass(document.body, 'show-submenu');
  }
  HelpOnOut() {
    this.helpStyle = 'is-closed';
    this.renderer.removeClass(document.body, 'show-submenu');
  }
  SearchOnOver() {
    this.searchStyle = 'is-open';
    this.renderer.addClass(document.body, 'show-submenu');
  }
  SearchOnOut() {
    this.searchStyle = 'is-closed';
    this.renderer.removeClass(document.body, 'show-submenu');
  }

  goToHome() {
    window.location.href = this.dataPortalUrl;
  }
  goToDataPortal(page: string) {
    
    window.location.href = this.dataPortalUrl + page;
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    //this.router.sk
    //this.router.navigate([currentUrl]);
    //this.router.navigate([currentUrl], { relativeTo: this.route, skipLocationChange: true})
    window.location.reload();
  }

  ngOnDestroy() {
    this.AuthSubscribtion.unsubscribe();
  }
}
